import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { FetchData } from 'app/shared/generalMethods';

@Component({
  selector: 'app-community-list',
  templateUrl: './community-list.component.html',
  styleUrls: ['./community-list.component.scss']
})
export class CommunityListComponent implements OnInit {
  communityData: any;
  displayedColumns: string[] = ['name', 'location', 'phone'];
  dataSource: any[] = [];
  parentId: any;
  allowCommunityCreation: boolean = false;
  isAdmin: boolean = false;

  constructor(
    private _router: Router,
    private _snackBar: MatSnackBar,
    private _fetchData: FetchData
  ) {}

  ngOnInit(): void {
    const { countAdmin, countStaff } = this._fetchData.data;

    this.allowCommunityCreation = this._fetchData.getAllowCommunityCreation();

    if (countAdmin === 1) {
      this.isAdmin = true;
      this.loadCommunityDataForAdmin();
    } else if (countStaff === 1) {
      this.isAdmin = false;
      this.loadCommunityDataForStaff();
    } else {
      this._snackBar.open('User role not identified as Admin or Staff.', 'Close', {
        duration: 3000
      });
    }
  }

  loadCommunityDataForAdmin(): void {
    const allLocations = this._fetchData.data?.lstLocations || [];

    // Filter locations that belong to the logged-in admin
    this.communityData = allLocations
      .filter(location => location)
      .map(location => ({
        communityid: location.Id,
        name: location.Name,
        location: location.Community_Location__c || '--',
        description: location.Community_Description__c || '--',
        contactPhone: location.Community_Phone__c || '--',
        adminIdOrUid: location.Administrator__c
      }));

    // Set the dataSource properly
    this.dataSource = this.communityData || [];

    // Set parentId if available
    if (this.communityData.length > 0) {
      this.parentId = this._fetchData.parentId;
    } else {
      this._snackBar.open('No community found or failed to fetch community.', 'Close', {
        duration: 3000
      });
    }
  }

  loadCommunityDataForStaff(): void {
    const allLocations = this._fetchData.data?.lstLocations || [];

    // Show all locations without filtering
    this.communityData = allLocations
      .filter(location => location)
      .map(location => ({
        communityid: location.Id,
        name: location.Name,
        location: location.Community_Location__c || '--',
        description: location.Community_Description__c || '--',
        contactPhone: location.Community_Phone__c || '--',
        adminIdOrUid: location.Administrator__c
      }));

    // Set the dataSource properly
    this.dataSource = this.communityData || [];

    // Set parentId if available
    if (this.communityData.length > 0) {
      this.parentId = this._fetchData.parentId;
    } else {
      this._snackBar.open('No community found or failed to fetch community.', 'Close', {
        duration: 3000
      });
    }
  }



// onCommunityClick(community: any): void {
//   if (this.isAdmin && community?.communityid) {
//     this._router.navigate(['/community-detail', community.communityid]);

//     this._snackBar.open(`Viewing details for ${community.name}`, 'Close', {
//       duration: 3000,
//       panelClass: ['success-snackbar']
//     });
//   } else {
//     this._snackBar.open('You are not authorized to view community details.', 'Close', {
//       duration: 3000,
//       panelClass: ['error-snackbar']
//     });
//   }
// }



  // onCommunityClick1(community: any): void {
  //   if (community?.Id) {
  //     // Navigate to community detail page
  //     this._router.navigate(['/community-detail', community.Id]);

  //     // Show notification with community name
  //     this._snackBar.open(`Viewing details for ${community.Name}`, 'Close', {
  //       duration: 3000,
  //       panelClass: ['success-snackbar'] // Optional: add custom styling class
  //     });
  //   } else {
  //     // Show error if no valid community ID
  //     this._snackBar.open('Unable to view community details', 'Close', {
  //       duration: 3000,
  //       panelClass: ['error-snackbar'] // Optional: add custom styling class
  //     });
  //   }
  // }
}
